import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
export default (function (registry) {
  return function createPage(Component) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var pageConfig = registry.page(options);
    var name = Component.displayName || Component.name || 'Page';

    function PageComponent(props) {
      var page = /*#__PURE__*/React.createElement(Component, props);
      var children = pageConfig.render(props, page);
      return children;
    }

    PageComponent.displayName = "createPage(".concat(name, ")");
    PageComponent.getInitialProps = pageConfig.enhanceInitialProps( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
        var getExtensionProps, getInitialProps, promise, allInitialProps;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                getExtensionProps = pageConfig.getInitialProps(ctx);
                getInitialProps = Component.getInitialProps ? Component.getInitialProps(ctx) : {};
                promise = Promise.all([getExtensionProps, getInitialProps]); // FIXME: https://github.com/zeit/next.js/issues/7599
                // Some requests will hang if the error page itself throws an error.
                // So make sure to catch that here only for the error page.

                if (ctx.pathname === '/_error') {
                  promise = promise["catch"](function (err) {
                    // eslint-disable-next-line no-console
                    console.error('Error while rendering /pages/_error! The page may be rendered with fallback content.'); // eslint-disable-next-line no-console

                    console.error(err);
                    return [];
                  });
                }

                _context.next = 6;
                return promise;

              case 6:
                allInitialProps = _context.sent;
                return _context.abrupt("return", Object.assign.apply(Object, [{}].concat(_toConsumableArray(allInitialProps))));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    hoistNonReactStatics(PageComponent, Component, {
      getInitialProps: true
    });
    return pageConfig.enhance(PageComponent);
  };
});